module.exports = __webpack_public_path__ + "img/bg_make_03.fac88dee.jpg";